import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { LegendComponent } from "../../../../../../common/components/legend_component";
import { LegendTagIcon } from "../../../../../../common/components/legend_tag_icon";
import { LegendTagItemComponent } from "../../../../../../common/components/legend_tag_item_component";

type Props = {
  open: boolean;
  onClose: () => void;
};

export const LegendaModal = ({
  open,
  onClose
}: Props) => {
  return (
    <Dialog
      open={open}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "45rem",
          },
        },
      }}>
      <DialogTitle>
        Legenda
      </DialogTitle>

      <DialogContent>
        <div className="flex flex-col flex-wrap">
          <LegendComponent label="Documentos">
            <LegendTagItemComponent
              icon={<LegendTagIcon color='green' title='DE' />}
              label='Em Dia' />

            <LegendTagItemComponent
              icon={<LegendTagIcon color='red' title='DV' />}
              label='Vencido' />

          </LegendComponent>

          <LegendComponent label="Habilidades">
            <LegendTagItemComponent
              icon={<LegendTagIcon color='green' title='HC' />}
              label='Concluídas' />

            <LegendTagItemComponent
              icon={<LegendTagIcon color='red' title='HA' />}
              label='Em atraso' />

            <LegendTagItemComponent
              icon={<LegendTagIcon color='yellow' title='HD' textColor='white' />}
              label='Dentro do prazo' />

            <LegendTagItemComponent
              icon={<LegendTagIcon color='gray' title='NH' />}
              label='Não possui' />

          </LegendComponent>

          <LegendComponent label="Treinamentos">
            <LegendTagItemComponent
              icon={<LegendTagIcon color='green' title='AC' />}
              label='Concluídas' />

            <LegendTagItemComponent
              icon={<LegendTagIcon color='red' title='AT' />}
              label='Em atraso' />

            <LegendTagItemComponent
              icon={<LegendTagIcon color='yellow' title='TNR' textColor='white' />}
              label='Não realizados' />

            <LegendTagItemComponent
              icon={<LegendTagIcon color='gray' title='NT' />}
              label='Não possui' />

          </LegendComponent>

          <LegendComponent label="Experiência">
            <LegendTagItemComponent
              icon={<LegendTagIcon color='green' title='EA' />}
              label='Aprovada' />

            <LegendTagItemComponent
              icon={<LegendTagIcon color='red' title='ER' />}
              label='Reprovada' />

            <LegendTagItemComponent
              icon={<LegendTagIcon color='yellow' title='EV' textColor='white' />}
              label='Vencida' />

            <LegendTagItemComponent
              icon={<LegendTagIcon color='gray' title='EE' />}
              label='Em Andamento' />

          </LegendComponent>
        </div>
      </DialogContent>

      <DialogActions>
        <div className="w-full h-full items-center justify-end flex p-4 gap-4">
          <div className="flex flex-row gap-2">
            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
              <h1
                className="text-sm text-black dark:text-white"
                onClick={onClose}>
                Fechar
              </h1>
            </div>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
}